import { FC, useContext, useEffect, useState } from 'react'
import { List, ListItem, ListItemText, Typography, Box, Avatar, Paper } from '@mui/material';
import { getCommentDetails, readUserNotification } from '../../services/openProject.service';
import { ProjectContext } from '../../Pages/Homepage';
import { formatDistanceStrict } from "date-fns";
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { toast } from 'react-toastify';

interface NotificationPopupType {
  notificationContent: any;
  handleClose: () => void;
}

const MentionedContainer: FC<any> = ({ notification }) => {
  const [mentionedText, setMentionedText] = useState("Loading...");

  const fetchCommentDetails = async () => {
    const activityId = notification?._links?.activity?.href?.split('activities/')?.[1];
    try {
      const commentDetails = await getCommentDetails(activityId)
      if (commentDetails?.data?.comment) {
        setMentionedText(commentDetails?.data?.comment?.raw)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchCommentDetails();
  }, []);

  return (
    <Paper elevation={2} sx={{ padding: "8px" }} >
      <div style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2
      }} >
        <div dangerouslySetInnerHTML={{ __html: mentionedText }} ></div>
      </div>
    </Paper>
  );
};

const NotificationTable: FC<NotificationPopupType> = ({ notificationContent, handleClose }) => {
  const { setSelectedNotification } = useContext(ProjectContext)
  const trackerState = useSelector((state: RootState) => state.tracker);
  const isIssueTracking = trackerState.isTracking

  const readNotification = async (id: string, notification: any) => {
    if (!isIssueTracking) {
      setSelectedNotification(JSON.parse(JSON.stringify(notification)));
      try {
        handleClose()
        await readUserNotification(id)
      } catch (err: any) {
        console.error("error in reading notification", err.message)
      }
    } else {
      toast.error('Tracker is Running')
    }
  }

  const formatRelativeTime = (date: any) => {
    return formatDistanceStrict(new Date(date), new Date(), { addSuffix: true });
  };

  return (
    <div>
      <Box sx={{ bgcolor: '#F4F5F7', padding: 1, borderBottom: '1px solid #ddd' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>Notifications</Typography>
      </Box>
      <List sx={{ width: '100%', maxHeight: 400, overflow: 'auto', bgcolor: 'white' }}>
        {
          notificationContent?.length === 0 ? (
            <ListItem sx={{ justifyContent: 'center', padding: 2 }}>
              <Typography variant="body2" color="textSecondary">No new notifications</Typography>
            </ListItem>
          ) : (
            notificationContent?.map((notification: any) => (
              <ListItem
                key={notification.id}
                divider
                sx={{ alignItems: 'flex-start', padding: 2, cursor: 'pointer', backgroundColor: notification.readIAN ? '#FFF' : '#e2f1fe' }}
                onClick={() => readNotification(notification.id, notification)}>
                <Avatar sx={{ bgcolor: '#0052CC', marginRight: 2 }}>{notification._links.actor.title.charAt(0)}</Avatar>
                <div style={{ width: "100%" }} >
                  <ListItemText
                    primary={
                      <div style={{ display: "flex" }} >
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {notification._links.actor.title} {notification.reason} you
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 'normal', color: "#8C9BAB", paddingLeft: 1 }}>
                          {formatRelativeTime(notification?.createdAt)}
                        </Typography>
                      </div>
                    }
                    secondary={
                      <>
                        <Typography component="span" variant="body2" color="textPrimary">
                          {notification._links.resource.title}
                        </Typography>
                        {` in ${notification._links.project.title}`}
                      </>
                    }
                  />
                  {notification.reason === "mentioned" && <MentionedContainer notification={notification} />}
                </div>
              </ListItem>
            ))
          )}
      </List>
    </div>
  )
}

export default NotificationTable